import { bsc, bscTestnet, goerli, mainnet } from 'wagmi/chains';
import {
  NetworkChainIds,
  enabledNetworksChainIds,
} from '@dapp/multi-lib/network';

export const SUPPORTED_NETWORKS: NetworkChainIds[] =
  enabledNetworksChainIds as NetworkChainIds[];

export const cardanoChainId = 6;

export const SUPPORTED_NETWORKS_CHAIN_ID: NetworkChainIds[] =
  SUPPORTED_NETWORKS;

export enum NETWORKS_NAMES {
  BNBChain = 'BNB Chain',
  Ethereum = 'Ethereum',
  Cardano = 'Cardano',
  All = 'All',
}

export enum SupportedNetworks {
  ETH = 'ETH',
  BSC = 'BSC',
  CARDANO = 'CARDANO',
}

export const SupportedNetworksIconMap = {
  ETH: 'ETH',
  BSC: 'BNB',
  CARDANO: 'ADA',
  HardhatLocalhost: 'HardhatLocalhost',
};

export const SupportedNetworksIconMapToIconify: Record<any, string> = {
  ETH: 'mingcute:ethereum-line',
  BSC: 'mingcute:binance-coin-bnb-fill',
  CARDANO: 'mingcute:cardano-ada-line',
  HardhatLocalhost: 'HardhatLocalhost',
};

export const SupportedNetworksNameMap: Record<any, string> = {
  ETH: 'Ethereum',
  BSC: 'BSC',
  CARDANO: 'CARDANO',
  HardhatLocalhost: 'HardhatLocalhost',
};

export const NETWORK_SCAN_LINK: Record<any, string> = {
  ETH: 'https://etherscan.io',
  BSC: 'https://bscscan.com',
  CARDANO: 'https://cardanoscan.io/',
  HardhatLocalhost: '',
};

export const SUPPORTED_ETH_CHAINS: NetworkChainIds[] = [mainnet.id, goerli.id];
export const SUPPORTED_BSC_CHAINS: NetworkChainIds[] = [bsc.id, bscTestnet.id];

export const hasChainUpdated = (
  selectedChain: NetworkChainIds,
  chainId: NetworkChainIds
): boolean => {
  const bscNetworks: NetworkChainIds[] = [bsc.id, bscTestnet.id];
  const ethNetworks: NetworkChainIds[] = [mainnet.id, goerli.id];

  return bscNetworks.includes(chainId) || ethNetworks.includes(chainId);
};

export const getNetworkIdFromChainId = (
  chainId: NetworkChainIds
): NetworkChainIds => {
  return chainId;
};

export enum NETWORK_SWITCH_DISPLAY {
  DROPDOWN = 'DROPDOWN',
  SWITCH = 'SWITCH',
}
